import { useState } from "react";
import { svgs } from "../../../consts";
import { SvgImg } from "../../index";

const popularIcons = ["098", "124", "125", "099", "100", "101", "102", "103", "104", "105"];

const StepEventsTimeline = ({ formData, updateFormData, setFormData }) => {
  const [expandedEvent, setExpandedEvent] = useState(0);
  const [showIconPicker, setShowIconPicker] = useState(null);

  const addEvent = () => {
    const newEvent = {
      id: Date.now(),
      eventName: "",
      time: "",
      location: "",
      icon: "098",
      coordinates: { lat: 0, lng: 0 },
    };
    setFormData((prev) => ({
      ...prev,
      events: [...prev.events, newEvent],
    }));
    setExpandedEvent(formData.events.length);
  };

  const removeEvent = (index) => {
    if (formData.events.length <= 1) return;
    setFormData((prev) => ({
      ...prev,
      events: prev.events.filter((_, i) => i !== index),
    }));
    if (expandedEvent >= index && expandedEvent > 0) {
      setExpandedEvent(expandedEvent - 1);
    }
  };

  const updateEvent = (index, field, value) => {
    setFormData((prev) => ({
      ...prev,
      events: prev.events.map((event, i) =>
        i === index ? { ...event, [field]: value } : event
      ),
    }));
  };

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-amber-50 mb-4">
          <svg className="w-8 h-8 text-amber-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900">Događaji na vjenčanju</h3>
        <p className="text-sm text-gray-500 mt-1">Dodajte ceremoniju, ručak, zabavu...</p>
      </div>

      <div className="space-y-3">
        {formData.events.map((event, index) => (
          <div
            key={event.id || index}
            className={`border rounded-xl overflow-hidden transition-all ${
              expandedEvent === index ? "border-teal-300 bg-teal-50/50" : "border-gray-200"
            }`}
          >
            <button
              type="button"
              onClick={() => setExpandedEvent(expandedEvent === index ? -1 : index)}
              className="w-full px-4 py-3 flex items-center justify-between"
            >
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-white border border-gray-200 flex items-center justify-center overflow-hidden">
                  {event.icon ? (
                    <SvgImg
                      src={`/svg/${event.icon}.svg`}
                      highlightColor={formData.highlightColor}
                      size={24}
                    />
                  ) : (
                    <span className="text-lg text-gray-400">{index + 1}</span>
                  )}
                </div>
                <div className="text-left">
                  <p className="font-medium text-gray-900">
                    {event.eventName || `Događaj ${index + 1}`}
                  </p>
                  {event.time && (
                    <p className="text-sm text-gray-500">{event.time}</p>
                  )}
                </div>
              </div>
              <svg
                className={`w-5 h-5 text-gray-400 transition-transform ${
                  expandedEvent === index ? "rotate-180" : ""
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>

            {expandedEvent === index && (
              <div className="px-4 pb-4 space-y-4">
                <div className="grid grid-cols-2 gap-4">
                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Naziv događaja
                    </label>
                    <input
                      type="text"
                      value={event.eventName}
                      onChange={(e) => updateEvent(index, "eventName", e.target.value)}
                      placeholder="npr. Ceremonija vjenčanja"
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Vrijeme
                    </label>
                    <input
                      type="time"
                      value={event.time}
                      onChange={(e) => updateEvent(index, "time", e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Ikona
                    </label>
                    <button
                      type="button"
                      onClick={() => setShowIconPicker(showIconPicker === index ? null : index)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm flex items-center justify-between hover:bg-gray-50"
                    >
                      {event.icon ? (
                        <SvgImg
                          src={`/svg/${event.icon}.svg`}
                          highlightColor={formData.highlightColor}
                          size={20}
                        />
                      ) : (
                        <span className="text-gray-400">Odaberi</span>
                      )}
                      <svg className="w-4 h-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  </div>

                  <div className="col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Lokacija
                    </label>
                    <textarea
                      value={event.location}
                      onChange={(e) => updateEvent(index, "location", e.target.value)}
                      placeholder="npr. Katedrala sv. Duje, Split"
                      rows={2}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"
                    />
                  </div>
                </div>

                {showIconPicker === index && (
                  <div className="p-3 bg-white border border-gray-200 rounded-lg">
                    <p className="text-xs text-gray-500 mb-2">Popularne ikone</p>
                    <div className="grid grid-cols-5 gap-2">
                      {popularIcons.map((iconId) => (
                        <button
                          key={iconId}
                          type="button"
                          onClick={() => {
                            updateEvent(index, "icon", iconId);
                            setShowIconPicker(null);
                          }}
                          className={`aspect-square rounded-lg border flex items-center justify-center hover:bg-gray-50 p-1 ${
                            event.icon === iconId ? "border-teal-500 bg-teal-50" : "border-gray-200"
                          }`}
                        >
                          <SvgImg
                            src={`/svg/${iconId}.svg`}
                            highlightColor={formData.highlightColor}
                            size={28}
                          />
                        </button>
                      ))}
                    </div>
                    <div className="mt-3 pt-3 border-t border-gray-100">
                      <p className="text-xs text-gray-500 mb-2">Više ikona</p>
                      <div className="grid grid-cols-6 gap-2 max-h-40 overflow-y-auto">
                        {Object.values(svgs).slice(0, 48).map((src) => {
                          const iconId = src.slice(5, 8);
                          return (
                            <button
                              key={iconId}
                              type="button"
                              onClick={() => {
                                updateEvent(index, "icon", iconId);
                                setShowIconPicker(null);
                              }}
                              className={`aspect-square rounded border flex items-center justify-center hover:bg-gray-50 p-1 ${
                                event.icon === iconId ? "border-teal-500 bg-teal-50" : "border-gray-200"
                              }`}
                            >
                              <SvgImg
                                src={src}
                                highlightColor={formData.highlightColor}
                                size={24}
                              />
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

                {formData.events.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeEvent(index)}
                    className="text-sm text-red-600 hover:text-red-700 flex items-center gap-1"
                  >
                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                    Ukloni događaj
                  </button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={addEvent}
        className="w-full py-3 border-2 border-dashed border-gray-300 rounded-xl text-gray-600 hover:border-teal-400 hover:text-teal-600 transition-colors flex items-center justify-center gap-2"
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Dodaj novi događaj
      </button>

      <div className="border-t border-gray-200 pt-6 mt-6">
        <h4 className="text-sm font-medium text-gray-900 mb-4">Dodatne opcije</h4>
        
        <div className="space-y-4">
          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <span className="text-sm font-medium text-gray-700">Vremenska crta</span>
              <p className="text-xs text-gray-500">Prikaži događaje na vremenskoj crti</p>
            </div>
            <input
              type="checkbox"
              checked={formData.timelineWithQuote}
              onChange={(e) => updateFormData({ timelineWithQuote: e.target.checked })}
              className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
            />
          </label>

          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <span className="text-sm font-medium text-gray-700">Karta lokacija</span>
              <p className="text-xs text-gray-500">Prikaži sve lokacije na karti</p>
            </div>
            <input
              type="checkbox"
              checked={formData.includeMap}
              onChange={(e) => updateFormData({ includeMap: e.target.checked })}
              className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
            />
          </label>

          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <span className="text-sm font-medium text-gray-700">Odbrojavanje</span>
              <p className="text-xs text-gray-500">Prikaži odbrojavanje do vjenčanja</p>
            </div>
            <input
              type="checkbox"
              checked={formData.countdown}
              onChange={(e) => updateFormData({ countdown: e.target.checked })}
              className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
            />
          </label>

          <label className="flex items-center justify-between cursor-pointer">
            <div>
              <span className="text-sm font-medium text-gray-700">Inicijali / Pečat</span>
              <p className="text-xs text-gray-500">Prikaži inicijale mladenaca</p>
            </div>
            <input
              type="checkbox"
              checked={formData.includeEmblem}
              onChange={(e) => updateFormData({ includeEmblem: e.target.checked })}
              className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
            />
          </label>
        </div>
      </div>

      {formData.timelineWithQuote && (
        <div className="border-t border-gray-200 pt-6">
          <h4 className="text-sm font-medium text-gray-900 mb-4">Citat</h4>
          <label className="flex items-center justify-between cursor-pointer mb-4">
            <span className="text-sm font-medium text-gray-700">Prikaži citat</span>
            <input
              type="checkbox"
              checked={formData.quote}
              onChange={(e) => updateFormData({ quote: e.target.checked })}
              className="w-5 h-5 text-teal-600 border-gray-300 rounded focus:ring-teal-500"
            />
          </label>

          {formData.quote && (
            <div className="space-y-3">
              <textarea
                value={formData.quoteText}
                onChange={(e) => updateFormData({ quoteText: e.target.value })}
                placeholder="Unesite citat..."
                rows={2}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 resize-none"
              />
              <input
                type="text"
                value={formData.quoteAuthor}
                onChange={(e) => updateFormData({ quoteAuthor: e.target.value })}
                placeholder="Autor citata (opcionalno)"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-teal-500"
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StepEventsTimeline;
